import { readableDeviceName } from '@iotv/core-services';
import { edgeTypeMatrix } from '@iotv/datamodel-core';
import { AppValueTypes, DeviceTypes } from '@iotv/iotv-v3-types';
import { AdjacentType } from '../../../types';
export const viewDefinition = {
    name: {
        key: 'name',
        editable: false,
        label: 'name',
        precision: undefined,
        stateFn: undefined,
        type: AppValueTypes.STRING,
        unit: undefined,
        validationRx: undefined,
    },
    numChildren: {
        key: 'numChildren',
        editable: false,
        label: 'numChildren',
        precision: undefined,
        stateFn: undefined,
        // valueGetter: getNumChildren,
        type: AppValueTypes.STRING,
        unit: undefined,
        validationRx: undefined,
    },
};
export const groupIsAllowedByUserGroup = {
    adjacentType: AdjacentType.PARENT,
    objectType: 'Group',
    edgeFilter: { edgeTypeId: edgeTypeMatrix.Group.Group.group_allows_group.edgeTypeId },
    groupSupportedType: 'User',
};
export const groupFilter = {
    adjacentType: AdjacentType.CHILD,
    objectType: 'Group',
    edgeFilter: {
        edgeTypeId: edgeTypeMatrix.Group.Group.group_has_subGroup.edgeTypeId,
    },
};
export const groupConfigParams = {
    enabled: false,
    multipleSelect: false,
    controls: {
        add: true,
    },
};
/** @deprecated in favour of {@link GroupViewDefinition | `GroupViewDefinition`} */
export const devGatewayGroupViewDefinition = {
    name: {
        key: 'name',
        label: 'Name',
        type: AppValueTypes.STRING,
        editable: true,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
    description: {
        key: 'description',
        label: 'Description',
        type: AppValueTypes.STRING,
        editable: true,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
};
/**
 * Should not be used for `Group`'s, as it lacks `supportedType` and others
 *
 * NOTE: not deprecated, as it remains widely used as a base view definition — it's just poorly named
 */
export const GroupViewDefinition = {
    name: {
        key: 'name',
        label: 'Name',
        type: AppValueTypes.STRING,
        editable: true,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
    description: {
        key: 'description',
        label: 'Description',
        type: AppValueTypes.STRING,
        editable: true,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
};
export const VisibleGroupsViewDefinition = {
    ...GroupViewDefinition,
    type: {
        key: 'supportedType',
        label: 'Type',
        type: AppValueTypes.STRING,
        editable: false,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
};
/** @deprecated in favour of `getListViewDefinition()` */
export const devGatewayViewDefinition = {
    name: {
        key: 'name',
        label: 'Name',
        type: AppValueTypes.STRING,
        editable: false,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
    deviceType: {
        key: 'deviceType',
        label: 'Device Type',
        type: AppValueTypes.ENUM,
        enumKV: Object.fromEntries(Object.entries(DeviceTypes)
            .filter(([k, v]) => !isNaN(parseInt(v)))
            .map(([k, v]) => [readableDeviceName(v), v])),
        editable: false,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
    eui: {
        key: 'eui',
        label: 'EUI',
        type: AppValueTypes.STRING,
        editable: false,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
    lastSeen: {
        key: 'lastSeen',
        label: 'Last Seen',
        type: AppValueTypes.TIMESTAMP_MS,
        editable: false,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
    batteryLevel: {
        key: 'batteryLevel',
        label: 'Battery (V)',
        type: AppValueTypes.NUMBER,
        editable: false,
        unit: 'volts',
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
};
/** @deprecated in favour of `getListViewDefinition()` */
export const gatewayViewDefinition = {
    name: {
        key: 'name',
        label: 'Name',
        type: AppValueTypes.STRING,
        editable: false,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
    eui: {
        key: 'eui',
        label: 'EUI',
        type: AppValueTypes.STRING,
        editable: false,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
    lastSeen: {
        key: 'lastSeen',
        label: 'Last Seen',
        type: AppValueTypes.TIMESTAMP_MS,
        editable: false,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
    /** Battery Level not likely to be relevant on gateway */
    batteryLevel: {
        key: 'batteryLevel',
        label: 'Battery V',
        type: AppValueTypes.NUMBER,
        editable: false,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
};
